import I18n from 'I18n';
// @ts-expect-error Untyped library
import ReactCodeMirror from 'react-codemirror';
import styled, { css } from 'styled-components';
import { OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CodeMirrorThemeNames } from 'developer-docs-shared-components/utils/CodeMirrorTheme';
import { NEXT_COMPONENT_SPACING } from 'developer-docs-shared-components/config/cssConstants';
import memoizeOne from 'react-utils/memoizeOne';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CopyButtonContainer = styled.div.withConfig({
  displayName: "Pre__CopyButtonContainer",
  componentId: "akp0uh-0"
})(["position:absolute;right:20px;z-index:5;"]);
const PreWrapper = styled.div.withConfig({
  displayName: "Pre__PreWrapper",
  componentId: "akp0uh-1"
})(["position:relative;.react-codemirror{margin-bottom:", "px;}.CodeMirror-sizer{padding-top:16px;padding-bottom:16px !important;}"], NEXT_COMPONENT_SPACING);
const CodeMirror = styled(ReactCodeMirror).withConfig({
  displayName: "Pre__CodeMirror",
  componentId: "akp0uh-2"
})(["", ""], ({
  lineNumbers
}) => !lineNumbers && css(["&{.CodeMirror-lines{padding-inline-start:1rem;}}"]));

/**
 * Class name applied to the `<pre />` tag, derived from CodeMirror package.
 * @example 'language-js'
 */

/**
 * User-provided code block language with optional theme suffix. Light theme
 * can be applied by appending `--light` to a Markdown code block language.
 *
 * @example
 * ````
 * ```shell--light
 *   npx cowsay "Your moo neighbor"
 * ```
 * `````
 */

/**
 * Mode describing the code block language.
 * @example 'hubl-html'
 */

/**
 * Returns a valid CodeMirror theme name. Currently only light and dark are
 * available. Case insensitive.
 *
 * @default 'DARK'
 */
const getValidThemeName = memoizeOne(themeStr => {
  if (themeStr) {
    const validThemes = Object.keys(CodeMirrorThemeNames);
    const computedThemeName = themeStr.toUpperCase();
    if (validThemes.includes(computedThemeName)) {
      return computedThemeName;
    }
  }
  // Default theme
  return 'DARK';
});
const MDX_PRE_CLASS_TO_MODE = {
  'language-js': 'application/javascript',
  'language-json': 'application/json',
  'language-shell': 'shell',
  // There are multiple types of hubl (like hubl-html). Need to differentiate.
  'language-hubl': 'hubl-html',
  'language-html': 'htmlmixed',
  'language-css': 'css',
  'language-graphql': 'graphql',
  'language-yaml': 'yaml'
};
function Pre({
  children: {
    props: {
      children,
      className: classNameWithTheme = ''
    }
  }
}) {
  /**
   * Light theme can be applied by appending `--light` to a Markdown code block
   * language.
   */
  const [className, mode] = classNameWithTheme.toLowerCase().split('--');
  const computedMode = MDX_PRE_CLASS_TO_MODE[className] || null;
  const computedTheme = getValidThemeName(mode);
  const content = children.trim();
  const lineCount = content.split('\n').length;
  return /*#__PURE__*/_jsxs(PreWrapper, {
    children: [/*#__PURE__*/_jsx(CopyButtonContainer, {
      children: /*#__PURE__*/_jsx(UICopyButton, {
        use: "unstyled",
        value: content,
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "duplicate",
          size: "xxs",
          color: computedTheme === 'DARK' ? OLAF : OBSIDIAN,
          screenReaderText: I18n.text('developer-docs-mdx-components.accessibility.copyCodeSnippet')
        })
      })
    }), /*#__PURE__*/_jsx(CodeMirror, {
      height: "auto",
      width: "100%",
      lineWrapping: true,
      mode: computedMode,
      readOnly: true,
      theme: CodeMirrorThemeNames[computedTheme]
      // Only show line numbers if there is more than one
      ,
      lineNumbers: lineCount > 1,
      value: content
    })]
  });
}
export default Pre;